export default "__VITE_ASSET__2d5a6b71__"